import Icon from '../components/Icon.vue'

Icon.register({"pills":{"width":576,"height":512,"paths":[{"d":"M112 32C50.1 32 0 82.1 0 144V368C0 429.9 50.1 480 112 480S224 429.9 224 368V144C224 82.1 173.9 32 112 32zM160 256H64V144C64 117.5 85.5 96 112 96S160 117.5 160 144V256zM299.7 226.3C296.2 222.8 290.3 223.2 287.4 227.1 242.1 289.6 247 377.2 303.3 433.5 359.6 489.8 447.2 494.7 509.7 449.4 513.7 446.5 514 440.6 510.5 437.1L299.7 226.3zM529.5 207.3C473.2 151 385.6 146.1 323.1 191.4 319.1 194.3 318.8 200.2 322.3 203.7L533.1 414.5C536.6 418 542.5 417.6 545.4 413.7 590.7 351.1 585.9 263.6 529.5 207.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pills.js
// module id = GsVk
// module chunks = 0